import {h} from 'preact';
import {useState} from "preact/hooks";

import LoadingSpinner from "../LoadingSpinner";
import qrCodeService from "../../service/qrCodeService";
import designService from "../../service/designService";
import Renderer from "../../canvas/renderer";
import store from "../../store";
import * as actions from "../../actions";
import constants from '../../constants';
import { SyncOutlined } from '@ant-design/icons';

export default function PublishChangesButton({designId, updateElementAttribute, websiteToken, isMobile, pageNumError, dsa, showPublishWarningBanner}) {
  const [isClickedLinkUpdate, setClickedLinkUpdate] = useState(false);
  const [isSyncedAll, setIsSyncedAll] = useState(false);

  let waitingLink = false;
  let waitingQR = false;

  async function syncQRCode() {
    if (!window.data.design.qrCodeId && !window.data.design.landingPageId && !window.data.design.justAddedToLP) {
      waitingQR = false;
      showPublished();
      return;
    }

    updateElementAttribute('isSyncingQR', true);
    store.dispatch(actions.setIsSyncingQR(true));

    setClickedLinkUpdate(true);

    await qrCodeService.updateQRCodeDesignLink(designId);
    designService.refreshQRThumbnail(designId).then(() => {
      console.log('=> finished refreshing qr thumnbail');
    });

    store.dispatch(actions.setInSync(true));
    updateElementAttribute('isSyncingQR', false);
    store.dispatch(actions.setIsSyncingQR(false));
    waitingQR = false;
    showPublished();
  }

  async function saveDesign() {
    await designService.updateDesignHtml({
      id: designId,
      html: Renderer.getPagesContent(),
      hasVideo: store.getState().hasVideo
    });
  }

  async function syncShareLink() {
    if (!websiteToken && !dsa) {
      waitingLink = false;
      showPublished();
      return;
    }

    updateElementAttribute('isSyncing', true);
    store.dispatch(actions.setIsSyncing(true));

    await qrCodeService.createOrUpdateShareLink(designId);
    if (dsa) {
      qrCodeService.createOrUpdateShareLink(designId, constants.SL_TYPE_DSA).then(() => {
        console.log('=> finished publishing DSA');
      });
      store.dispatch(actions.setInSync(true));
      updateElementAttribute('isSyncing', false);
      store.dispatch(actions.setIsSyncing(false));

      setClickedLinkUpdate(false);
      setIsSyncedAll(true);
      setTimeout(() => {
        setIsSyncedAll(false)
      }, 3000);
    } else {
      store.dispatch(actions.setInSync(true));
      updateElementAttribute('isSyncing', false);
      store.dispatch(actions.setIsSyncing(false));
    }

    waitingLink = false;
    showPublished();
  }

  async function syncAll(e) {
      e.stopPropagation();
      if (pageNumError) return;
      setClickedLinkUpdate(true);
      waitingLink = true;
      waitingQR = true;
      showPublishWarningBanner();
      await saveDesign();
      await syncShareLink();
      await syncQRCode();
  }

  function showPublished() {
    if(!waitingLink && !waitingQR) {
      setClickedLinkUpdate(false);
      setIsSyncedAll(true);
      setTimeout(() => {
        setIsSyncedAll(false)
      }, 3000);
    }
  }

  return (
  <div className={`dropdown-toggle button large publish-changes ${pageNumError ? 'page-num-error' : ''}`} onClick={(e) => syncAll(e)}>
    {isClickedLinkUpdate && <LoadingSpinner/>}
    {!isClickedLinkUpdate && !isSyncedAll && <SyncOutlined/>}
    {!isClickedLinkUpdate && !isSyncedAll && <span>Publish</span>}
    {!isClickedLinkUpdate && isSyncedAll && <span>Published!</span>}
  </div>
  )
}

